(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSitePartSearch', PublicSitePartSearch);

    PublicSitePartSearch.$inject = ['$resource'];

    function PublicSitePartSearch($resource) {
        var resourceUrl =  'api/_search/public-site-parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
